// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import {
  NewPlanningPeriod,
  type PlanningPeriod,
  type PlanningPeriodWireFormat,
} from '../PlanningPeriod/PlanningPeriod';

export class PlanningYear {
  readonly id: string;
  readonly label: string;
  readonly startDate: DateTime;
  readonly periods: PlanningPeriod[];

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.label = data.label === undefined ? '' : data.label;
    this.startDate = DateHelpers.ParseServerDate(data.startDate);
    this.periods = (data.periods ?? []).map((periods: any) => NewPlanningPeriod(periods));
  }

  static zero(): PlanningYear {
    const zeroValues: ExcludeMethodsDeep<PlanningYear> = {
      id: NIL_UUID,
      label: '',
      startDate: DateHelpers.ParseServerDate(DateHelpers.ZERO_DATE_STRING),
      periods: [],
    };
    return new PlanningYear(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type PlanningYearWireFormat = {
  id: string;
  label: string;
  startDate: string;
  periods: PlanningPeriodWireFormat[];
};

type NewPlanningYearProps = PartialDeep<PlanningYear, { recurseIntoArrays: true }>;
export const NewPlanningYear: (props: NewPlanningYearProps) => PlanningYear = (props) =>
  new PlanningYear(props);

type NewPlanningYearFromWireFormatProps = PartialDeep<
  PlanningYearWireFormat,
  { recurseIntoArrays: true }
>;
export const NewPlanningYearFromWireFormat: (
  props: NewPlanningYearFromWireFormatProps,
) => PlanningYear = (props) => new PlanningYear(props);
